<div class="mt-2 mb-2 px-1">
  <div class="row mb-1 justify-content-between align-items-center">
    <div class="col-md-4 col-sm-6">
      <h4>{{'Dashboard' | translate}}</h4>
    </div>
    <div class="col-md-4 col-sm-6">
      <bi-control-list-2col [formGroup]="FormGroup" [controlList]="FilterControl" noOfRows =1>
      </bi-control-list-2col>
    </div>
  </div>
  <!-- end page title -->

  <div class="row">
    <div class="col-xl-8 col-lg-8">
      <div class="row">
        <div *ngFor="let dashboard of dashboards;let i=index" class="col-md-6 col-sm-6 col-lg-6 col-xs-6">
          <div class="card widget-flat">
            <div class="card-body">
              <app-linegraph newstyle="height: 10rem;" [holeSize]='30'
                [ctrMetaData]="{'DataType':'donut','Name':dashboards[i][0].name }"
                [data]="dashboards[i]"></app-linegraph>
            </div> <!-- end card-body-->
          </div> <!-- end card-->
        </div> <!-- end col-->
        <!-- end col-->
      </div> <!-- end row -->
    </div> <!-- end col -->

    <div class="col-xl-4 col-lg-4">
      <div class="card card-h-100 card-30h">
        <div class="card-body">
          <div dir="ltr" *ngIf="dashboardValues && barChartNames.length > 0">
            <select #mySelect (change)="onChangeBarChart($event,0)" class="form-control">
              <ng-container *ngFor="let target of dashboardValues">
                <option value="{{target.id}}">{{gettargetname(target)}}</option>
              </ng-container>
            </select>
            <app-linegraph newstyle="height: 27rem;" [ctrMetaData]="{'DataType':'bar','Name':'kk'}"
              [Categories]="[translateService.instant('PrevMonth'), translateService.instant('CurrentMonth')]"
              [Data]="[ barChart ]"></app-linegraph>
          </div>
        </div> <!-- end card-body-->
      </div> <!-- end card-->
    </div> <!-- end col -->
  </div>
</div>